/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SamlLoginRespose } from '../../models/saml-login-respose';

export interface SsoGetSamlLogin$Params {
  code?: string | null;
}

export function ssoGetSamlLogin(http: HttpClient, rootUrl: string, params?: SsoGetSamlLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<SamlLoginRespose>> {
  const rb = new RequestBuilder(rootUrl, ssoGetSamlLogin.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SamlLoginRespose>;
    })
  );
}

ssoGetSamlLogin.PATH = '/SSO/saml/GetSAMLLogin';
